import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Roundtripbookingmumbai() {



    const cardData = {




keyword: "Round Trip Cab Booking Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Round Trip Cab Booking in Mumbai for weekend trips, family vacations, business travel, pilgrimage tours, sightseeing packages, and long-distance outstation journeys. We provide round trip taxi services with flexible travel plans, experienced chauffeurs, and well-maintained vehicles for comfortable return journeys. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for couples, families, corporate groups, and large travelers. With doorstep pickup anywhere in Mumbai, customized travel itineraries, transparent pricing, easy booking, professional drivers, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and convenient travel experience. Whether you are planning a hill station tour, religious trip, corporate outing, family holiday, or sightseeing journey from Mumbai to nearby and long-distance destinations, our round trip cab service provides complete travel convenience with comfortable return arrangements.",

topPlaces: [
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is one of Maharashtra's most popular hill stations, known for Venna Lake, Arthur's Seat, Elephant's Head Point, strawberry farms, waterfalls, and scenic viewpoints. Round trip cabs are ideal for enjoying a relaxed hill station vacation with flexible sightseeing."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a favorite weekend destination from Mumbai, famous for Tiger Point, Bhushi Dam, Rajmachi Fort, caves, waterfalls, and beautiful valleys. Round trip taxi booking allows travelers to explore multiple attractions comfortably."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is a major pilgrimage destination famous for Sai Baba Temple. Round trip cab services provide convenient travel options for families, senior citizens, and devotees visiting Shirdi and nearby religious places."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, temples, and scenic attractions. Round trip taxi services are suitable for religious tours, wine tourism, and family trips."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is a popular holiday destination famous for beaches, forts, churches, resorts, and nightlife. Round trip cab bookings offer comfortable road travel with flexible stops and sightseeing options."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai, known for beaches, forts, resorts, and peaceful surroundings. It is a preferred destination for weekend vacations, family outings, and couple trips."
  },
  {
    title: "Mumbai to Matheran",
    description: "Matheran is a peaceful hill station near Mumbai famous for viewpoints, forest trails, toy train rides, and pollution-free surroundings. Round trip cabs provide convenient transportation for nature lovers and families."
  },
  {
    title: "Mumbai to Bhimashankar",
    description: "Bhimashankar is a famous Jyotirlinga temple destination surrounded by forests and scenic landscapes. It is popular among devotees, trekking enthusiasts, and nature lovers looking for a spiritual getaway."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad is a historic destination known for Ajanta and Ellora Caves, Bibi Ka Maqbara, forts, and cultural heritage. Round trip taxi services are preferred for heritage tours and family vacations."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is famous for Mahalakshmi Temple, Panhala Fort, Rankala Lake, and rich Maratha history. Round trip cab booking provides comfortable travel for religious trips, sightseeing, and family journeys."
  }
],



"services": [
  {
    "name": "Round Trip Cab Booking Mumbai",
    "description": "Book Round Trip Cab Booking Mumbai for comfortable return journeys with professional chauffeurs, well-maintained AC vehicles, and affordable travel packages. Choose Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options for family trips, business travel, sightseeing, and outstation journeys with flexible schedules."
  },
  {
    "name": "Mumbai Round Trip Cab Service",
    "description": "Choose Mumbai Round Trip Cab Service for reliable two-way transportation with experienced drivers and comfortable vehicles. Enjoy hassle-free travel for holidays, business visits, family functions, pilgrimage tours, and weekend getaways from Mumbai to various destinations."
  },
  {
    "name": "Mumbai Round Trip Taxi Booking",
    "description": "Complete Mumbai Round Trip Taxi Booking with easy reservations, transparent pricing, and multiple vehicle choices. Get dedicated cabs for return journeys with professional chauffeurs, doorstep pickup, and customized travel plans according to your requirements."
  },
  {
    "name": "Mumbai Return Cab Service",
    "description": "Book Mumbai Return Cab Service for convenient pickup and drop travel with affordable round trip packages. Enjoy comfortable AC cars, reliable drivers, and flexible timing options for personal trips, corporate travel, airport transfers, and sightseeing."
  },
  {
    "name": "Mumbai Round Trip Taxi Fare",
    "description": "Check Mumbai Round Trip Taxi Fare with affordable packages and transparent pricing without hidden charges. Travel comfortably with Sedan, Ertiga, Innova Crysta, SUV, and premium cabs available for short and long-distance return journeys."
  },
  {
    "name": "Mumbai Outstation Round Trip Cab",
    "description": "Hire Mumbai Outstation Round Trip Cab for safe and comfortable long-distance travel with experienced chauffeurs and premium vehicles. Perfect for destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states with flexible return travel options."
  },
  {
    "name": "Mumbai Weekend Trip Cab",
    "description": "Book Mumbai Weekend Trip Cab for relaxing short vacations and quick getaways with comfortable vehicles and professional drivers. Travel conveniently to hill stations, beaches, temples, and tourist destinations with customized weekend travel packages."
  },
  {
    "name": "Mumbai Family Round Trip Taxi",
    "description": "Choose Mumbai Family Round Trip Taxi for safe and spacious travel with family-friendly vehicles and experienced chauffeurs. Enjoy comfortable journeys for vacations, family functions, pilgrimage visits, and sightseeing tours with convenient return booking options."
  },
  {
    "name": "Mumbai Tour Cab Booking",
    "description": "Reserve Mumbai Tour Cab Booking for sightseeing trips, holiday tours, and customized travel packages. Explore nearby attractions and outstation destinations with comfortable AC vehicles, professional drivers, and flexible travel schedules."
  },
  {
    "name": "Mumbai Car Rental Round Trip",
    "description": "Book Mumbai Car Rental Round Trip for private chauffeur-driven vehicles with affordable rental packages. Choose from multiple car categories for family trips, corporate travel, tourist tours, and long-distance return journeys with complete comfort."
  },
  {
    "name": "Mumbai Return Taxi Service",
    "description": "Choose Mumbai Return Taxi Service for convenient two-way transportation with reliable drivers, clean vehicles, and affordable fares. Enjoy smooth travel for personal, business, airport, and leisure journeys with scheduled return options."
  },
  {
    "name": "Mumbai Round Trip Cab Package",
    "description": "Select Mumbai Round Trip Cab Package for customized travel solutions with flexible duration, vehicle options, and affordable pricing. Perfect for sightseeing, weekend trips, family tours, corporate travel, and outstation journeys requiring return transportation."
  }
],
"tableData": [
  ["Round Trip Cab Booking Mumbai", "Mumbai Round Trip Cab Service"],
  ["Mumbai Round Trip Taxi Booking", "Mumbai Return Cab Service"],
  ["Mumbai Round Trip Taxi Fare", "Mumbai Outstation Round Trip Cab"],
  ["Mumbai Weekend Trip Cab", "Mumbai Family Round Trip Taxi"],
  ["Mumbai Tour Cab Booking", "Mumbai Car Rental Round Trip"],
  ["Mumbai Return Taxi Service", "Mumbai Round Trip Cab Package"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Round Trip Cab Booking in Mumbai",
    WhyChoosedescription: "Shreesha Tours & Travels offers comfortable round trip cab services from Mumbai for local sightseeing, family trips, business travel, weekend getaways, and outstation journeys with convenient return options."
  },
  {
    WhyChooseheading: "Travel to Your Destination & Return Comfortably",
    WhyChoosedescription: "Plan your complete journey with a single cab booking. Our round trip taxi service ensures the same vehicle and professional driver are available for your onward and return travel."
  },
  {
    WhyChooseheading: "Perfect for Outstation Tours from Mumbai",
    WhyChoosedescription: "Book round trip cabs for popular destinations like Pune, Lonavala, Mahabaleshwar, Goa, Nashik, Shirdi, Kolhapur, Surat, Ahmedabad, and many other locations."
  },
  {
    WhyChooseheading: "Multiple Vehicles for Small & Large Groups",
    WhyChoosedescription: "Select from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses based on your passenger count."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Distance Travel",
    WhyChoosedescription: "Our skilled chauffeurs understand highway routes, travel schedules, and customer requirements to provide safe and comfortable round trip journeys."
  },
  {
    WhyChooseheading: "Flexible Packages with Customized Stops",
    WhyChoosedescription: "Add sightseeing locations, meal breaks, religious destinations, business stops, or multiple locations according to your travel plan."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Extended Journeys",
    WhyChoosedescription: "Travel in clean, air-conditioned, well-maintained vehicles with spacious seating and luggage capacity for a relaxed round trip experience."
  },
  {
    WhyChooseheading: "Easy Round Trip Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, and dependable service for your Mumbai round trip taxi requirements."
  }
]

};

const faqData = [
  {
    question: "What is a round trip cab booking service?",
    answer: "A round trip cab booking allows you to travel from Mumbai to your destination and return back using the same booked taxi service."
  },
  {
    question: "Can I book a round trip taxi from Mumbai for sightseeing?",
    answer: "Yes, round trip cabs are ideal for sightseeing tours, weekend trips, family vacations, and customized travel plans."
  },
  {
    question: "Which vehicles are available for round trip booking?",
    answer: "You can book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Can I book a round trip cab for religious tours?",
    answer: "Yes, many customers book round trip taxis from Mumbai for destinations like Shirdi, Nashik, Trimbakeshwar, Ashtavinayak temples, and Jyotirlinga tours."
  },
  {
    question: "Do you provide round trip cabs for corporate travel?",
    answer: "Yes, round trip taxi services are available for business meetings, client visits, conferences, and official travel."
  },
  {
    question: "Can I customize my round trip itinerary?",
    answer: "Yes, you can add sightseeing stops, multiple destinations, waiting time, and travel preferences according to your requirements."
  },
  {
    question: "Is the same driver available for the return journey?",
    answer: "Yes, depending on availability, the same professional driver can manage your complete round trip journey."
  },
  {
    question: "How is the round trip taxi fare calculated?",
    answer: "The fare depends on the vehicle category, total travel distance, number of travel days, route, and additional stops included."
  },
  {
    question: "Can I book a round trip cab from Mumbai Airport?",
    answer: "Yes, pickup and return travel can be arranged from Mumbai Airport, railway stations, hotels, offices, or residential locations."
  },
  {
    question: "How can I book a Round Trip Cab in Mumbai?",
    answer: "Share your pickup location, destination, travel dates, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback: "We booked a round trip cab from Mumbai to Mahabaleshwar with Shreesha Tours & Travels. The vehicle was comfortable, the driver was professional, and the entire trip was perfectly managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepa Rao",
    feedback: "Our family selected an Innova Crysta for a round trip journey from Mumbai. The booking process was simple, the car was spacious, and the travel experience was excellent.",
    rating: 5
  }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Booking Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/round-trip-cab-booking-mumbai.webp",
  "description":
    "Book Round Trip Cab Booking Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide round-trip cabs with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, family vacations, religious tours, sightseeing, airport transfers, and weekend getaways across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/round-trip-cab-booking-mumbai"
  }
};







    return (
        <div>

<Helmet>
  <title>Round Trip Cab Booking Mumbai | Return Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Round Trip Cab Booking Mumbai with Shreesha Travels for reliable return taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable outstation round trips with 24x7 online cab booking and experienced drivers."
  />

  <meta
    name="keywords"
    content="Round Trip Cab Booking Mumbai, Mumbai Round Trip Cab Service, Mumbai Round Trip Taxi Booking, Mumbai Return Cab Service, Mumbai Round Trip Taxi Fare, Mumbai Outstation Round Trip Cab, Mumbai Return Taxi Booking, Round Trip Taxi Mumbai, Mumbai Round Trip Car Rental, Mumbai Outstation Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Roundtripbookingmumbai;